import { useSelector } from 'react-redux';

const useCurrentProfile = () => {
  const currentUser = useSelector(state => state.auth.currentUser);

  return currentUser.profiles?.find(p => p.id === currentUser.profile_id);
};

export default useCurrentProfile;
